// extracted by mini-css-extract-plugin
module.exports = {"intro":"intro_intro__3RhBl","introExpando":"intro_introExpando___8Lmh","contactButton":"intro_contactButton__1Dr70","contactEmailIcon":"intro_contactEmailIcon__1dtnC"};